import React from "react";

import { EvaluableProp, withEvaluators } from "../../withEvaluators";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { useTypedSelector } from "../../../../../Common/UseTypedSelector";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";
import { CurrencyHelper } from "../../Internals/ControlsReexport/CustomControls/CurrencyInput/CurrencyHelper";
import { isNullOrEmpty } from "../../../../../Common/TypingUtils";

export interface ExprEvalProps {
    expression: EvaluableProp<string | Big | number>;
    processEvaluableProp: <T>(state: FullFormState, prop: EvaluableProp<T>) => T;
    currency?: boolean;
    currencyFractionDigits?: number;
    currencyShowZeroIfEmpty?: boolean;
}

const ExprEval = ({
    expression,
    processEvaluableProp,
    currencyFractionDigits,
    currency,
    currencyShowZeroIfEmpty,
}: ExprEvalProps) => {
    const fullState = useTypedSelector(state => state);
    const value = processEvaluableProp(fullState, expression)?.toString();
    const formattedValue =
        currency == true
            ? CurrencyHelper.format(currencyShowZeroIfEmpty && isNullOrEmpty(value) ? "0" : value, {
                  fractionDigits: currencyFractionDigits,
                  hideTrailingZeros: false,
              })
            : value;
    return <>{formattedValue}</>;
};

export const ExprEvalContainer = withResolvePaths(withViewModelSelect(withEvaluators(ExprEval)));
